const $Accordian1ATrigger = $('.component-accordian-1A__trigger');

$Accordian1ATrigger.on('click', function() {
    var $this = $(this);
    var $child = $('.component-accordian-1A__child', $this.parents('.component-accordian-1A__accordian-item'));
    
    if (!$this.is('.active')) {
        $('.component-accordian-1A__trigger').removeClass('active');
        $('.component-accordian-1A__child').slideUp('slow');
        $(this).addClass('active');
        $child.slideDown('slow');
    } else {
        $(this).removeClass('active');
        $child.slideUp('slow');
    }
});